import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue'

const deferredPrompt = ref<any>(null)
const isInstalled = ref(false)
const isIOS = ref(false)
const showBanner = ref(false)

export function usePwaInstall() {
  const checkIfInstalled = () => {
    try {
      const isStandaloneMedia = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(display-mode: standalone)')?.matches
      const isNavigatorStandalone = typeof window !== 'undefined' && (window.navigator as any)?.standalone === true
      const isAndroidApp = typeof document !== 'undefined' && Boolean(document.referrer?.includes('android-app://'))
      return Boolean(isStandaloneMedia || isNavigatorStandalone || isAndroidApp)
    } catch {
      return false
    }
  }

  const handleBeforeInstallPrompt = (e: Event) => {
    e.preventDefault()
    deferredPrompt.value = e
    const dismissed = localStorage.getItem('pwa_install_dismissed') === 'true'
    if (!dismissed && !checkIfInstalled()) {
      showBanner.value = true
    }
  }

  const handleAppInstalled = () => {
    isInstalled.value = true
    showBanner.value = false
    deferredPrompt.value = null
    localStorage.setItem('pwa_install_dismissed', 'true')
  }

  if (getCurrentInstance()) {
    onMounted(() => {
      isInstalled.value = checkIfInstalled()
      isIOS.value = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream

      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      window.addEventListener('appinstalled', handleAppInstalled)
    })

    onUnmounted(() => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      window.removeEventListener('appinstalled', handleAppInstalled)
    })
  }

  const promptInstall = async () => {
    if (!deferredPrompt.value) return false
    try {
      deferredPrompt.value.prompt()
      const choice = await deferredPrompt.value.userChoice
      if (choice && choice.outcome === 'accepted') {
        isInstalled.value = true
        showBanner.value = false
        localStorage.setItem('pwa_install_dismissed', 'true')
      }
      deferredPrompt.value = null
      return choice?.outcome === 'accepted'
    } catch (err) {
      console.error('PWA install error:', err)
      return false
    }
  }

  const dismissBanner = () => {
    showBanner.value = false
    localStorage.setItem('pwa_install_dismissed', 'true')
  }

  return {
    deferredPrompt,
    isInstalled,
    isIOS,
    showBanner,
    promptInstall,
    dismissBanner
  }
}
